import axiosInstance from '../utils/axiosConfig';

const bankReconService = {
    uploadStatement(file, guidance) {
        const formData = new FormData();
        formData.append('file', file);
        if (guidance) formData.append('guidance', guidance);
        return axiosInstance.post('/api/bank-recon/upload/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    getExtractionProgress(uploadId) {
        return axiosInstance.get(`/api/bank-recon/extraction-progress/${uploadId}/`);
    },

    confirmStatement(uploadId, overrides = {}) {
        return axiosInstance.post(`/api/bank-recon/confirm/${uploadId}/`, overrides);
    },

    discardUpload(uploadId) {
        return axiosInstance.delete(`/api/bank-recon/discard/${uploadId}/`);
    },

    getStatements(filters = {}) {
        const params = new URLSearchParams();
        if (filters.hms_entity) params.append('hms_entity', filters.hms_entity);
        if (filters.statement_date) params.append('statement_date', filters.statement_date);
        if (filters.currency) params.append('currency', filters.currency);
        const qs = params.toString();
        return axiosInstance.get(`/api/bank-recon/statements/${qs ? '?' + qs : ''}`);
    },

    getStatementLines(statementId) {
        return axiosInstance.get(`/api/bank-recon/statements/${statementId}/lines/`);
    },

    downloadStatement(statementId) {
        return axiosInstance.get(`/api/bank-recon/statements/${statementId}/download/`, {
            responseType: 'blob',
        });
    },

    // Phase 3+4+5: Matching & Reconciliation
    runMatching(statementId) {
        return axiosInstance.post(`/api/bank-recon/statements/${statementId}/run-matching/`);
    },

    approveAutoMatches(statementId) {
        return axiosInstance.post(`/api/bank-recon/statements/${statementId}/approve-auto-matches/`);
    },

    getReconciliationSummary(statementId) {
        return axiosInstance.get(`/api/bank-recon/statements/${statementId}/reconciliation-summary/`);
    },

    getReconciliationLines(statementId) {
        return axiosInstance.get(`/api/bank-recon/statements/${statementId}/reconciliation-lines/`);
    },

    getLineMatches(statementId, lineId) {
        return axiosInstance.get(`/api/bank-recon/statements/${statementId}/lines/${lineId}/matches/`);
    },

    confirmMatch(statementId, lineId, matchId) {
        return axiosInstance.post(`/api/bank-recon/statements/${statementId}/lines/${lineId}/matches/${matchId}/confirm/`);
    },

    rejectMatch(statementId, lineId, matchId) {
        return axiosInstance.post(`/api/bank-recon/statements/${statementId}/lines/${lineId}/matches/${matchId}/reject/`);
    },

    unmatchLine(statementId, lineId) {
        return axiosInstance.post(`/api/bank-recon/statements/${statementId}/lines/${lineId}/unmatch/`);
    },

    manualMatch(statementId, lineId, data) {
        return axiosInstance.post(`/api/bank-recon/statements/${statementId}/lines/${lineId}/manual-match/`, data);
    },

    matchWithoutDocument(statementId, lineId, data) {
        return axiosInstance.post(`/api/bank-recon/statements/${statementId}/lines/${lineId}/match-without-document/`, data);
    },

    searchDocuments(statementId, lineId, query = '', docType = '') {
        const params = new URLSearchParams();
        if (query) params.append('q', query);
        if (docType) params.append('type', docType);
        const qs = params.toString();
        return axiosInstance.get(`/api/bank-recon/statements/${statementId}/lines/${lineId}/search-documents/${qs ? '?' + qs : ''}`);
    },
};

export default bankReconService;
